import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';

@Component({
  selector: 'app-project-diagramation-archivos-img',
  templateUrl: './project-diagramation-archivos-img.component.html',
  styleUrls: ['./project-diagramation-archivos-img.component.scss']
})
export class ProjectDiagramationArchivosImgComponent implements OnInit {

  id_diagrama_archivo: number = 0;

  selectedImage!: string;
  currentIndex = 0;
  imagenes: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private main : MainService,
    private projectsS: ProjectsService,
  ) { }

  ngOnInit(): void {
    this.id_diagrama_archivo = this.data.id;
    const imagenesRecibidas = Array.isArray(this.data?.imagenes) ? this.data.imagenes : [];
    if (imagenesRecibidas.length) {
      this.imagenes = imagenesRecibidas
        .map((imagen: any) => typeof imagen === 'string' ? imagen : imagen?.file)
        .filter((imagen: string) => !!imagen);
      this.selectedImage = this.imagenes[0];
      return;
    }
    this.getImages();
  }

  getImages(){
    this.main.ShowLoading();
    const data = {
        id: this.id_diagrama_archivo,
    }
    this.projectsS.getDiagramaArchivosImages(data).subscribe((x: any) => {
      x.data.map((item:any) => {
        this.imagenes.push(item.file)
      })
      this.selectedImage = this.imagenes[0];
      this.main.HideLoading();
    },
    (err:any) => {
      console.log(err);
          this.main.HideLoading();
    })
  }

  changeImage(index: number) {
    this.currentIndex = index;
    this.selectedImage = this.imagenes[index];
  }

   prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.selectedImage = this.imagenes[this.currentIndex];
    }
  }

  nextImage() {
    if (this.currentIndex < this.imagenes.length - 1) {
      this.currentIndex++;
      this.selectedImage = this.imagenes[this.currentIndex];
    }
  }

}
